const colors = [
    '#1976D2',
    '#FF0000',
    '#27B4D1',
    '#6F2EA3',
    '#DC7C08',
];

// 48 - 57 === 0 - 9
// 65 - 90 A-Z
export function getSuggestionColor(letter) {
    const code = (letter || '').toUpperCase().charCodeAt();

    if (code >= 48 && code <= 57) {
        return colors[(code - 48) % colors.length];
    }

    if (code >= 65 && code <= 90) {
        return colors[(code - 65) % colors.length];
    }

    return colors[0];
}
